import type { HelpTip } from './interfaces';

const HELP_MENU_STATE_KEY = 'whats-new';

const OPENED_TIPS_STORAGE_KEY = 'openedTips';

const SHELTER_MODULE_FLAGS = [
  'account_codes_enabled',
  'adopt_a_pet_opt_in',
  'adopt_app',
  'adoption_contract',
  'behavior',
  'bite_report_outside_field_services',
  'cash_drawer',
  'community_support',
  'docupet_enabled',
  'enable_bite_report',
  'enable_clinic_out_payments',
  'enable_groups_litters',
  'enable_migrated_receipts',
  'enable_products',
  'enable_saved_reports',
  'enable_service_out_payments',
  'enable_shelter_census',
  'equipment_rental_enabled',
  'field_services',
  'field_services_dispatch',
  'hills_report',
  'lost_found',
  'outcome_contracts_migrated',
  'petcademy',
  'petco_love_lost_enabled',
  'rehome',
  'tnvr',
  'transports',
  'unlimited_forms',
  'use_kennel_manager',
  'vca_report',
];

const HELP_TIPS: HelpTip[] = [
  {
    addedOn: '2026-10-19',
    articleKey: 'field-services-dispatch',
    key: 'field-services-dispatch',
    navKey: 'fieldServices_dispatcher',
    requires: { feature_flags: ['field_services', 'field_services_dispatch'], role: 'field-services' },
    route: { name: 'field-services-dispatcher' },
    showUntil: '2026-11-18',
  },
  {
    addedOn: '2026-10-19',
    articleKey: 'whats_new',
    key: 'whats_new',
    route: { name: 'support-whats-new' },
    showUntil: '2026-11-18',
  },
  {
    addedOn: '2026-10-20',
    articleKey: 'saved-reports',
    key: 'saved-reports',
    requires: { feature_flags: ['enable_saved_reports'] },
    route: { name: 'animals-in-care' },
    showUntil: '2026-11-19',
  },
  {
    addedOn: '2026-10-20',
    articleKey: 'filters-and-columns',
    key: 'filters-and-columns',
    route: { name: 'animals-in-care' },
    showUntil: '2026-11-19',
  },
  {
    addedOn: '2026-10-21',
    articleKey: 'species-adoption-contracts',
    // NOTE :: Species contracts only work once the shelter's contracts are migrated, so New stays off
    // there for everyone, super admins included. The legacy pages read a copy of this tip from the
    // api's config/help_tips.php — keep both equal.
    availableWhen: ['outcome_contracts_migrated'],
    key: 'species-adoption-contracts',
    requires: { feature_flags: ['adoption_contract', 'outcome_contracts_migrated'], role: 'outcome-settings' },
    route: { name: 'settings-outcome-contracts', params: { outcomeType: 'adopted' } },
    showUntil: '2026-11-20',
  },
  {
    addedOn: '2026-10-21',
    articleKey: 'adoption-applications-per-species',
    key: 'adoption-applications-per-species',
    // NOTE :: The control is the Adoption Application link in the settings menu, tagged with this key
    // in the api's config/settings_navigation.php. Legacy pages read a copy from config/help_tips.php.
    requires: { feature_flags: ['adopt_app'], role: 'adoptions' },
    route: { name: 'settings-home' },
    showUntil: '2026-11-20',
  },
  {
    addedOn: '2026-10-26',
    articleKey: 'tnvr-case-animals',
    key: 'tnvr-case-animals',
    requires: { feature_flags: ['tnvr'], role: 'tnvr' },
    route: { name: 'tnvr-calls' },
    showUntil: '2026-11-05',
  },
  {
    addedOn: '2026-10-26',
    articleKey: 'community-support-case-animals',
    key: 'community-support-case-animals',
    requires: { feature_flags: ['community_support'], role: 'community-support' },
    route: { name: 'community-support-active-support' },
    showUntil: '2026-11-05',
  },
];

export { HELP_MENU_STATE_KEY, HELP_TIPS, OPENED_TIPS_STORAGE_KEY, SHELTER_MODULE_FLAGS };
